import { Component, input } from '@angular/core';
import { ParagraphPgForm } from '@app/models/paragraph.model';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { TextComponent } from '@app/components/text/text.component';
import { MediaComponent } from '@app/components/media/media.component';
import { HeadingSelectComponent } from '@app/components/heading-select/heading-select.component';
import { WebformModule } from '@app/components/webform/webform.module';
import { EntitySharedModule } from '@app/modules/entity.shared.module';

@Component({
  selector: 'mobi-paragraph-pg-form',
  templateUrl: './paragraph-pg-form.component.html',
  styleUrls: ['./paragraph-pg-form.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    ContentSectionComponent,
    TextComponent,
    MediaComponent,
    HeadingSelectComponent,
    WebformModule,
  ],
})
export class ParagraphPgFormComponent {
  readonly paragraph = input.required<ParagraphPgForm>();
}
